import { Box, StyledHtml, Text } from '@postenbring/hedwig-react';

export const SummaryBox = ({boxBody, boxTitle}) => {
    return (
        <Box>
            <Text variant="body-title" as="h4" className="hds-mb-4-8">{boxTitle}</Text>
            {boxBody &&
                <StyledHtml dangerouslySetInnerHTML={{ __html: boxBody }}></StyledHtml>
            }
        </Box>
    )
}